const handleTabFeaturedCollections = () => {
    const featuredNavItem = document.querySelectorAll(".c-featured-nav__item");
    if (featuredNavItem.length > 0) {
        featuredNavItem.forEach((link) => {
            link.addEventListener("click", function () {
                const dataHandle = this.getAttribute("data-handle");
                const urlData = this.getAttribute("data-url");
                const parentCollection = this.closest(".c-featured-collection");
                const tabContents = parentCollection.querySelectorAll(
                    ".c-featured-content"
                );
                const featuredNavItemChild = parentCollection.querySelectorAll(
                    ".c-featured-nav__item"
                );
                const urlElement =
                    parentCollection.querySelectorAll(".c-seeMore");
                if (urlElement) {
                    console.log("urlElement", urlElement)
                    urlElement.forEach((item) =>
                        item.setAttribute("href", urlData)
                    );
                }
                tabContents.forEach((content) => {
                    if (content.id === dataHandle) {
                        content.classList.remove("hidden");
                    } else {
                        content.classList.add("hidden");
                    }
                });
                featuredNavItemChild.forEach((link) => {
                    link.classList.remove("is-active");
                });

                this.classList.add("is-active");
            });
        });
    }
};

const handleTabSearchByCategory = () => {
    const featuredNavItem = document.querySelectorAll(".c-catSearch__navItem");
    if (featuredNavItem.length > 0) {
        featuredNavItem.forEach((link) => {
            link.addEventListener("click", function () {
                const dataHandle = this.getAttribute("data-handle");
                console.log(this.closest(".c-catSearch"));
                const parentCollection = this.closest(".c-catSearch");
                const tabContents = parentCollection.querySelectorAll(
                    ".c-cateSearch__tagContent"
                );
                const featuredNavItemChild = parentCollection.querySelectorAll(
                    ".c-catSearch__navItem"
                );

                tabContents.forEach((content) => {
                    if (content.id === dataHandle) {
                        content.classList.remove("hidden");
                    } else {
                        content.classList.add("hidden");
                    }
                });

                featuredNavItemChild.forEach((link) => {
                    link.classList.remove("is-active");
                });

                this.classList.add("is-active");
            });
        });
    }
};

const handleSearchInput = () => {
    $(".c-search__input").on("keypress", function (event) {
        if (event.which === 13) {
            const inputValue = $(this).val();
            const redirectUrl = "/search?q=" + encodeURIComponent(inputValue);
            window.location.href = redirectUrl;
            event.preventDefault();
        }
    });
};

document.addEventListener("DOMContentLoaded", () => {
    handleTabFeaturedCollections();
    handleTabSearchByCategory();
    handleSearchInput();
});
